import { Row, Col } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import axios from 'axios';

const Bannerbar = () => {
  const user = useSelector((state: any) => state.user);
  const [bannerData, setBannerData] = useState<any>([]);

  useEffect(() => {
    getBanner();
  }, []);

  const getBanner = async () => {
    const { data } = await axios.get(`/banner/`);

    setBannerData(data.data);
  };

  return (
    <>
      {bannerData.length > 0 ? (
        <div
          style={{
            maxWidth: '1200px',
            margin: '54px auto 0px auto',
          }}
        >
          <Row>
            <Col xs={{ span: 24 }} md={{ span: 24 }}>
              <a
                href='https://promptdee.com/shops/?from=myShops&id=629f5da8209ab4179c91a1f3'
                target={`_blank`}
              >
                <img
                  alt=''
                  src={bannerData[0]?.url}
                  style={{
                    maxWidth: '100%',
                    objectFit: 'contain',
                    height: 'auto',
                  }}
                />
              </a>
            </Col>
          </Row>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default Bannerbar;
